import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function aliasValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // no validar si está vacío (usa Validators.required por separado si lo necesitas)
    }
    const value: string = control.value.toLowerCase();

    // Regla: solo caracteres permitidos
    const allowedRegex = /^[a-z0-9^$.!`\-#+'\~_áéíóúñÑÁÉÍÓÚ\s]+$/;
    if (!allowedRegex.test(value)) {
      return { aliasInvalid: 'Contains invalid characters' };
    }

    return null;
  };
}
